// Textos fixos da oração guiada (não vêm do banco).

// Passo "presenca" — Presença de Deus.
export const PRESENCA_INTRO =
  'Faça o sinal da cruz, sem pressa. Respire fundo três vezes. Deus está aqui com você.';

// A oração do Espírito Santo em partes, para dar destaque à resposta.
export const PRESENCA_ORACAO_INICIO =
  'Vinde, Espírito Santo, enchei os corações dos vossos fiéis e acendei neles o fogo do vosso amor.';
export const PRESENCA_LINHA_1 = '— Enviai o vosso Espírito e tudo será criado.';
export const PRESENCA_LINHA_2 = '— E renovareis a face da terra.';
export const PRESENCA_ORACAO_FIM =
  'Oremos: Ó Deus, que instruístes os corações dos vossos fiéis com a luz do Espírito Santo, concedei-nos que no mesmo Espírito saibamos o que é reto e gozemos sempre da sua consolação. Por Cristo, Senhor nosso. Amém.';

export const RUBRICA_RESPIRA = 'Respire fundo três vezes.';
export const LEGENDA_INSPIRA = 'Inspire devagar…';
export const LEGENDA_SOLTA = 'Solte o ar devagar…';
export const LEGENDA_PRESENCA = 'Deus está aqui com você.';

// Passo "biblia" — Pegue a sua Bíblia.
export const DICA_BIBLIA =
  'Na Bíblia, o número grande é o capítulo; os números pequenos dentro do texto são os versículos.';
export const DICA_BIBLIA_2 = 'Leia com calma, se puder em voz alta.';
export const LINK_CNBB = 'https://liturgiadiaria.edicoescnbb.com.br/';
export const NOVO_TESTAMENTO = 'Novo Testamento';

// Passo "padre" — Palavra do padre.
export const RUBRICA_PADRE = 'Depois de ouvir, continue a oração.';

// Passo "vida" — Olhe para a sua vida.
export const RUBRICA_VIDA = 'Responda no seu coração, sem pressa.';
export const ROMANOS = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII'];

// Passo "termine" — Pai-Nosso.
export const PAI_NOSSO = [
  'Pai nosso que estais nos céus, santificado seja o vosso nome,',
  'venha a nós o vosso reino, seja feita a vossa vontade, assim na terra como no céu.',
  'O pão nosso de cada dia nos dai hoje,',
  'perdoai-nos as nossas ofensas, assim como nós perdoamos a quem nos tem ofendido,',
  'e não nos deixeis cair em tentação, mas livrai-nos do mal.',
  'Amém.',
];

export const SINAL_CRUZ = 'Em nome do Pai, e do Filho e do Espírito Santo. Amém.';

// Vocativos do fim.
export const FIM_AMANHA = 'Amanhã às 6h chega a próxima oração.';